import PropTypes from 'prop-types'
import React, { useState } from 'react'
import clsx from 'clsx'
import TimePickerField from './TimePickerField'
import * as validations from '../../../utils/validations'
import useFieldValue from '../../../hooks/useFieldValue'
import { getDateFromTime, getNextToHour } from '../../../utils/helpers'
import { useField } from 'react-final-form'

const TimeRangeField = ({
  className,
  startName,
  startLabel,
  endName,
  endLabel,
  interval = 60,
  disabled,
  initialStartHour = '0:00',
  initialEndHour = '22:00',
  minRangeDifference = 1,
  required
}) => {
  const startValue = useFieldValue(startName)
  const endValue = useFieldValue(endName)
  const { input: inputEnd } = useField(endName)
  const [startToHour, setStartToHour] = useState(getNextToHour(startValue, interval, minRangeDifference))
  const isRequired = required || Boolean(startValue || endValue)

  const handleStartHourChange = value => {
    const nextEndMinHour = getNextToHour(value, interval, minRangeDifference)
    setStartToHour(nextEndMinHour)

    const dateEnd = getDateFromTime(endValue)
    const dateMinEnd = getDateFromTime(nextEndMinHour)

    if (dateEnd < dateMinEnd || !endValue) {
      inputEnd.onChange(nextEndMinHour)
    }
    if (!value) {
      inputEnd.onChange('')
    }
  }

  return (
    <div className={clsx(className, 'flex flex-col gap-6')}>
      <TimePickerField
        name={startName}
        label={startLabel}
        end={initialEndHour}
        start={initialStartHour}
        emptyLabel="Hora de inicio"
        validate={isRequired ? validations.required() : null}
        menuProps={{ PaperProps: { id: 'timeStartPicker' } }}
        disabled={disabled}
        interval={interval}
        onChange={handleStartHourChange}
      />
      <TimePickerField
        name={endName}
        label={endLabel}
        start={startToHour}
        emptyLabel="Hora de fin"
        validate={isRequired ? validations.required() : null}
        disabled={disabled || !startToHour}
        interval={interval}
      />
    </div>
  )
}
export default TimeRangeField

TimeRangeField.propTypes = {
  className: PropTypes.string,
  startName: PropTypes.string,
  startLabel: PropTypes.string,
  endName: PropTypes.string,
  endLabel: PropTypes.string,
  interval: PropTypes.number,
  disabled: PropTypes.bool,
  initialStartHour: PropTypes.string,
  initialEndHour: PropTypes.string,
  minRangeDifference: PropTypes.number,
  required: PropTypes.bool
}
